import { PortfolioView } from "@/features/S2Dashboard";

export default function PortfolioPage() {
  return <PortfolioView />;
}
